import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgZorgOmJeBuur = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F170B8"
      d="M27.99 26a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
    />
    <path
      fill="#fff"
      d="M29.56 21a1.4 1.4 0 0 1-1.17 1.38l-.08.48h-.81l-.12-1c.76 0 1.18-.31 1.18-.79a.64.64 0 0 0-.66-.63.73.73 0 0 0-.67.42l-.81-.38a1.57 1.57 0 0 1 1.52-1A1.5 1.5 0 0 1 29.56 21m-1.06 2.91a.59.59 0 0 1-.6.59.57.57 0 0 1-.58-.59.58.58 0 0 1 .58-.59.6.6 0 0 1 .6.59"
    />
    <path
      fill="#F8BADD"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v10H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M29.683 7.907a5.12 5.12 0 0 0-3.352-1.157h-.011c-.808 0-1.694.217-2.364.583-.691.377-1.016.828-1.016 1.247 0 .46.183.855.527 1.179l.03-.066a2.97 2.97 0 0 1 2.88-1.683c.816.002 1.555.13 2.11.406.57.283 1.013.766 1.013 1.454 0 .499-.268.972-.812 1.295-.522.31-1.295.485-2.368.485a6.6 6.6 0 0 1-1.988-.293 2.09 2.09 0 0 0 2.482 1.289l.252.968a3.09 3.09 0 0 1-3.854-2.708l-.003-.035.002-.034v-.01c-.751-.504-1.271-1.261-1.271-2.247 0-.971.73-1.685 1.537-2.125.825-.451 1.876-.704 2.838-.705a6.12 6.12 0 0 1 4.002 1.383zm-5.354 2.385c.558.23 1.247.358 1.99.358.988 0 1.555-.165 1.858-.345.281-.167.323-.334.323-.435 0-.182-.098-.38-.458-.559-.37-.184-.944-.301-1.682-.301h-.019l-.018-.001a1.97 1.97 0 0 0-1.994 1.283"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      d="M12.92 10.43a2.22 2.22 0 0 1-1.86 2.21l-.13.77H9.62l-.18-1.62c1.22 0 1.89-.5 1.89-1.27a1 1 0 0 0-1.06-1 1.17 1.17 0 0 0-1.07.67l-1.3-.6A2.5 2.5 0 0 1 10.34 8a2.4 2.4 0 0 1 2.58 2.43m-1.69 4.63a.94.94 0 0 1-1 .94.92.92 0 0 1-.93-.94.93.93 0 0 1 .93-1 1 1 0 0 1 1 1M13.03 31.99a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
    />
    <path
      fill="#fff"
      d="M15 25.76a1.73 1.73 0 0 1-1.45 1.73l-.11.59h-1l-.15-1.26c1 0 1.48-.39 1.48-1a.8.8 0 0 0-.83-.78.89.89 0 0 0-.83.52l-1-.47A2 2 0 0 1 13 23.86a1.87 1.87 0 0 1 2 1.9m-1.32 3.61a.74.74 0 0 1-.75.74.72.72 0 0 1-.73-.74.74.74 0 0 1 .73-.74.75.75 0 0 1 .74.74z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgZorgOmJeBuur);

export default ForwardRef;
